import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { X, Check, ZoomIn } from "lucide-react";
import getCroppedImg from "../utils/cropImage";

const ImageCropperModal = ({
  imageSrc,
  aspect = 1, // 1 para quadrado, 16/9 para retângulo, etc.
  onCropComplete,
  onClose,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCropChange = (crop) => { setCrop(crop); };
  const onZoomChange = (zoom) => { setZoom(zoom); };

  const onCropAreaChange = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = async () => {
    if (!croppedAreaPixels) return;
    setLoading(true);
    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropComplete(croppedImageBlob);
    } catch (e) {
      console.error("Erro ao recortar:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/75 p-5">
      <div className="flex w-full max-w-[500px] flex-col overflow-hidden rounded-2xl bg-white shadow-[0_10px_25px_rgba(0,0,0,0.2)] animate-[fadeIn_0.3s_ease-out]">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-warm-200 px-5 py-4">
          <h3 className="text-[1.2rem] font-semibold text-warm-900">Ajustar Imagem</h3>
          <button
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full text-warm-400 transition-colors hover:bg-warm-100 hover:text-rose-500"
          >
            <X size={24} />
          </button>
        </div>

        {/* Área de crop */}
        <div className="relative h-[300px] w-full bg-[#333]">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={onCropChange}
            onCropComplete={onCropAreaChange}
            onZoomChange={onZoomChange}
            objectFit="contain"
          />
        </div>

        {/* Controles */}
        <div className="flex flex-col gap-4 p-5">
          {/* Slider de zoom */}
          <div className="flex items-center gap-2.5 text-warm-400">
            <ZoomIn size={18} />
            <input
              type="range"
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby="Zoom"
              onChange={(e) => setZoom(Number(e.target.value))}
              className="flex-1 cursor-pointer accent-rose-400"
            />
          </div>

          {/* Ações */}
          <div className="flex justify-end gap-2.5">
            <button
              onClick={onClose}
              className="rounded-xl border border-warm-200 bg-warm-100 px-4 py-2.5 text-sm font-medium text-warm-700 hover:bg-warm-200 transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={handleSave}
              disabled={loading}
              className="flex items-center gap-2 rounded-xl bg-rose-400 px-4 py-2.5 text-sm font-semibold text-white hover:brightness-105 disabled:opacity-60 transition-colors"
            >
              {loading ? "Processando..." : <><Check size={18} /> Confirmar</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCropperModal;
